import { Icon } from '@iconify/react';
import React from 'react';
import Slider from 'react-slick';
import Div from '../Div';
import Team from '../Team';
const teamData = [
  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443120/cb8pgx55wwf1mpsbside.png',
    memberName: 'Jai Chachra',
    memberDesignation: 'Founder',
    memberSocial: {
      linkedin: 'https://www.linkedin.com/in/thejaichachra/',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },
  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443090/fj7musxy9r4ggxnnhqwq.png',
    memberName: 'Anish Yadav',
    memberDesignation: 'Innovation Catalyst',
    memberSocial: {
      linkedin: 'https://www.linkedin.com/in/anish-yadav/',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },
  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443169/ndkpsmyix38mn7rcv7s0.png',
    memberName: 'Vaibhav Goyal',
    memberDesignation: 'Strategic Powerhouse',
    memberSocial: {
      linkedin: '/',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },
  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443169/zc3nsubanzzbagolvkqm.png',
    memberName: 'Shivam Chauhan',
    memberDesignation: 'Director of Production',
    memberSocial: {
      linkedin: 'https://www.linkedin.com/in/shivam-chauhan-2a7815215/',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },
  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443162/mivqadygx3zmuwipslvc.png',
    memberName: 'Sakshi Uchaniya',
    memberDesignation: 'Brand Strategist',
    memberSocial: {
      linkedin: 'https://www.linkedin.com/in/sakshi-uchaniya-818026242/',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },
  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443129/gla7xqfbs11yq8tmvptp.png',
    memberName: 'Kartik Chachra',
    memberDesignation: 'Director Of Influencer Relations',
    memberSocial: {
      linkedin: 'https://www.linkedin.com/in/kartikchachra/',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },
  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443089/rnx2fdhxpjfxwz8a2poa.png',
    memberName: 'Animesh Kudake',
    memberDesignation: 'Project Manager',
    memberSocial: {
      linkedin: 'https://www.linkedin.com/in/animeshkudake/',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },
  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744488345/r92ht1tvmst1yzairj0t.jpg',
    memberName: 'Ayush Srivastava ',
    memberDesignation: 'Jr.Developer',
    memberSocial: {
      linkedin: 'https://in.linkedin.com/in/ayush-srivastava-b9871b246',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },
  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443127/hsuymixot9jq2dodnwoc.png',
    memberName: 'Harsh Vijay',
    memberDesignation: 'Software Developer  ',
    memberSocial: {
      linkedin: 'https://www.linkedin.com/in/harsh-vijay-ba6413193/',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },
  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443129/ouwxzwacg7kaj7buo87l.png',
    memberName: 'Inshra Fatma',
    memberDesignation: 'UI/UX Designer',
    memberSocial: {
      linkedin: 'https://www.linkedin.com/in/inshra-fatma/',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },
  // {
  //   memberImage: '/images/member_1.jpeg',
  //   memberName: 'Vrijesh Chauhan',
  //   memberDesignation: 'Software Trainee',
  //   memberSocial: {
  //     linkedin: '/',
  //     Linkedin: '/',
  //     youtube: '/',
  //     facebook: '/',
  //   },
  // },
  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443130/nxnvdl1erlpzx9yitac9.png',
    memberName: 'Monishka Goel',
    memberDesignation: 'SEO Exectutive',
    memberSocial: {
      linkedin: 'https://www.linkedin.com/in/monishka-goel-b66878261/',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },

  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443170/m4tz7tym3xxfra7kijxg.png',
    memberName: 'Vimukt Thakur',
    memberDesignation: 'Video Editor',
    memberSocial: {
      linkedin: 'https://www.linkedin.com/in/vimukt-thakur-31b851329/',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },
  {
    memberImage: 'https://res.cloudinary.com/djgqvtvkz/image/upload/v1744443129/izsccr2ybd6bwrr0alnw.png',
    memberName: 'Manas Dwivedi',
    memberDesignation: 'Graphic Designer',
    memberSocial: {
      linkedin: '/',
      // Linkedin: '/',
      // youtube: '/',
      // facebook: '/',
    },
  },

];

export default function TeamSlider() {
  /** Team Member Data **/

  /** Slider Settings **/
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    >
      <Icon icon="bi:arrow-left" />
    </div>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-next slick-arrow' +
        (currentSlide === slideCount - 1 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
    >
      <Icon icon="bi:arrow-right" />
    </div>
  );
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <Slider {...settings} className="cs-gap-24 cs-arrow_style2">
      {teamData.map((item, index) => (
        <Div key={index}>
          <Team
            memberImage={item.memberImage}
            memberName={item.memberName}
            memberDesignation={item.memberDesignation}
            memberSocial={item.memberSocial}
          />
        </Div>
      ))}
    </Slider>
  );
}
